import {
    NOTIFICATION_LIST_REQUEST,
    NOTIFICATION_LIST_RESPONSE,
    NOTIFICATION_LIST_SEARCH_REQUEST,
    NOTIFICATION_LIST_CACHED_RESPONSE,
    NOTIFICATION_LIST_ERROR_RESPONSE,
    NOTIFICATION_ITEM_REQUEST,
    NOTIFICATION_ITEM_RESPONSE,
    NOTIFICATION_ITEM_CACHED_RESPONSE,
    NOTIFICATION_ITEM_ERROR_RESPONSE,
    NOTIFICATION_ITEM_SAVE_REQUEST,
    NOTIFICATION_ITEM_SAVE_RESPONSE,
    NOTIFICATION_ITEM_DELETE_REQUEST,
    NOTIFICATION_ITEM_DELETE_RESPONSE,
    NOTIFICATION_ITEM_DELETE_ERROR_RESPONSE,
    NOTIFICATION_SET_FILTER,
    NOTIFICATION_SET_EDIT_MODE,
    NOTIFICATION_UPDATE_FILTER_CRITERIA,
    NOTIFICATION_CLEAR_FILTER_CRITERIA,
    NOTIFICATION_APPLY_FILTER_CRITERIA,
    NOTIFICATION_UPDATE_MODEL,
    NOTIFICATION_APPLY_MODEL_UPDATE,
    NOTIFICATION_CANCEL_MODEL_UPDATE,
    NOTIFICATION_ADD_NEW,
    NOTIFICATION_TOGGLE_EXPIRES,
    NOTIFICATION_ITEM_ENTITY_REQUEST,
    NOTIFICATION_ITEM_ENTITY_RESPONSE,
    NOTIFICATION_ITEM_ENTITY_ERROR_RESPONSE
} from "./action-types"

import {
    itemResponse,
    itemSaveRequest,
    itemDeleteRequest,
    itemDeleteResponse,
    itemCachedResponse,
    itemErrorResponse,
    itemDeleteErrorResponse,
} from "./default-actions/entity-actions"

import {
    itemRequest,
    setFilter,
    listSearchRequest,
    updateFilterCriteria,
    clearFilterCriteria,
    applyFilterCriteria,
    updateModel,
    applyModelUpdate,
    cancelModelUpdate,
    setEditMode,
    defaultAction,
} from "./default-actions/presentation-actions"

import {
    listRequest,
    listResponse,
    listCachedResponse,
    listErrorResponse,
    listInvalidationRequest,
} from "./default-actions/paging-actions"

// Paging Actions
export const notificationListRequest = listRequest(NOTIFICATION_LIST_REQUEST)
export const notificationListSearchRequest = listSearchRequest(
    NOTIFICATION_LIST_SEARCH_REQUEST
)
export const notificationListInvalidationRequest = listInvalidationRequest(
    NOTIFICATION_LIST_REQUEST
)
export const notificationListResponse = listResponse(NOTIFICATION_LIST_RESPONSE)
export const notificationListCachedResponse = listCachedResponse(
    NOTIFICATION_LIST_CACHED_RESPONSE
)
export const notificationListErrorResponse = listErrorResponse(
    NOTIFICATION_LIST_ERROR_RESPONSE
)

// Entity Actions
export const notificationItemRequest = itemRequest(NOTIFICATION_ITEM_REQUEST)
export const notificationItemResponse = itemResponse(NOTIFICATION_ITEM_RESPONSE)
export const notificationItemCachedResponse = itemCachedResponse(
    NOTIFICATION_ITEM_CACHED_RESPONSE
)
export const notificationItemErrorResponse = itemErrorResponse(
    NOTIFICATION_ITEM_ERROR_RESPONSE
)
export const notificationItemSaveRequest = itemSaveRequest(
    NOTIFICATION_ITEM_SAVE_REQUEST
)
export const notificationItemSaveResponse = itemResponse(
    NOTIFICATION_ITEM_SAVE_RESPONSE
)
export const notificationItemDeleteRequest = itemDeleteRequest(
    NOTIFICATION_ITEM_DELETE_REQUEST
)
export const notificationItemDeleteResponse = itemDeleteResponse(
    NOTIFICATION_ITEM_DELETE_RESPONSE
)
export const notificationItemDeleteErrorResponse = itemDeleteErrorResponse(
    NOTIFICATION_ITEM_DELETE_ERROR_RESPONSE
)

// Presentation Actions
export const notificationSetFilter = setFilter(NOTIFICATION_SET_FILTER)
export const notificationSetEditMode = setEditMode(NOTIFICATION_SET_EDIT_MODE)
export const notificationUpdateFilterCriteria = updateFilterCriteria(
    NOTIFICATION_UPDATE_FILTER_CRITERIA
)
export const notificationClearFilterCriteria = clearFilterCriteria(
    NOTIFICATION_CLEAR_FILTER_CRITERIA
)
export const notificationApplyFilterCriteria = applyFilterCriteria(
    NOTIFICATION_APPLY_FILTER_CRITERIA
)
export const notificationUpdateModel = updateModel(NOTIFICATION_UPDATE_MODEL)
export const notificationApplyModelUpdate = applyModelUpdate(
    NOTIFICATION_APPLY_MODEL_UPDATE
)
export const notificationCancelModelUpdate = cancelModelUpdate(
    NOTIFICATION_CANCEL_MODEL_UPDATE
)
export const notificationAddNew = defaultAction(NOTIFICATION_ADD_NEW)
export const notificationToggleExpires = defaultAction(NOTIFICATION_TOGGLE_EXPIRES)

export const notificationItemEntityRequest = (entityId, notificationType) => ({
    type: NOTIFICATION_ITEM_ENTITY_REQUEST,
    entityId,
    notificationType
})
export const notificationItemEntityResponse = (data, entityId, notificationType) => ({
    type: NOTIFICATION_ITEM_ENTITY_RESPONSE,
    data,
    entityId,
    notificationType
})
export const notificationItemEntityErrorResponse = itemErrorResponse(
    NOTIFICATION_ITEM_ENTITY_ERROR_RESPONSE
)